import React from "react";
import styles from "./Skills.module.css";
import skills from "../../Data/Skills";
import Fade from "react-reveal/Fade";
import Typewriter from "typewriter-effect";

const Skills = () => {
  return (
    <div className={styles.skillsMainDiv}>
      <h1>
        <Typewriter
          style={{ fontWeight: "bold" }}
          options={{
            autoStart: true,
            loop: true,
            delay: 40,
            strings: ["Skills()"],
          }}
        />
      </h1>
      <div>
        <div className={styles.skillsDiv}>
          {skills.map((item) => {
            return (
              <Fade top key={item} duration={2000}>
                <div className={styles.skillItem}>
                  <p>{item}</p>
                </div>
              </Fade>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Skills;
